import React, { useState, useEffect, useRef } from "react";
import UserModels from "./models/UserModels";
import "../compnents/css/table.css";
import { format } from "date-fns";
import { ViewModels } from "./models/ViewModels";

const Complaints = (props) => {
  const [aNumber, setAnumber] = useState("");
  const [brandName, setBrandName] = useState("");
  const [modal, setModal] = useState("");
  const [serialNumber, setSerialNumber] = useState("");
  const [pDate, setPdate] = useState("");
  const [Address, setAddress] = useState("");
  const [Issue, setIssue] = useState("");
  const [Pincode, setPincode] = useState("");
  const [isModalOpen, setModalStatus] = useState(false);
  const [isModalOpen2, setModalStatus2] = useState(false);
  const [users, setUser] = useState([]);
  const [name, setName] = useState("");
  const [pNumber, setPNumber] = useState("");
  const [complaintNumber, setComplaintNumber] = useState("");
  const [userId, setUserId] = useState(null);
  const textInput = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [typeOfComplaint, setTypeOfComplaint] = useState("");


  useEffect(() => {
    // eslint-disable-next-line
    getUsers();
  }, []);
  const getUsers = () => {
    fetch(`${process.env.REACT_APP_NEWS_API}/api/users`)
      .then((result) => {
        result.json().then((resp) => {
          setUser(resp);
        });
      })

      .catch((err) => console.log(err));
  };

  // const deleteUser = (id) => {
  //   fetch(`http://localhost:5000/api/users/${id}`, {
  //     method: "DELETE",
  //   }).then((result) => {
  //     result.json().then((resp) => {
  //       console.warn(`${id}`, resp);
  //     });
  //     getUsers();
  //   });
  // };
  const ViewUsers = (item) => {
    setModalStatus2(true);
    setUserId(item._id);
    setName(item.name);
    setPNumber(item.pNumber);
    setBrandName(item.brandName)
    setModal(item.modal)
    setSerialNumber(item.serialNumber)
    setAnumber(item.aNumber)
    setPdate(item.pDate)
    setPincode(item.Pincode)
    setAddress(item.Address)
    setIssue(item.Issue)
    setComplaintNumber(item.complaintNumber);
    setTypeOfComplaint(item.typeOfComplaint)
  };
  const selectUser = (item) => {
    setModalStatus(true);
    setUserId(item._id);
    setPNumber(item.pNumber);
    setName(item.name);
    setComplaintNumber(item.complaintNumber);
  };

  const updateUser = () => {
    let item = { name, pNumber, complaintNumber };
    fetch(`http://localhost:5000/api/users/${userId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    })
      .then((result) => {
        result.json().then((resp) => {
          console.warn(resp);
        });
        setName("");
        setUserId("");
        setPNumber("");
        setComplaintNumber("");
        setTimeout(() => {
          setModalStatus(false);
        }, 1000);
        getUsers();
      })
      .catch((err) => console.log(err));
      
  };
  return (
    <>
      <div className="table-body">
        <div className="table-users">
          <div
            className="header"
            style={{ textAlign: "center", fontSize: "30px" }}
          >
            Customer Complaint
          </div>

          <div>
            <form action="">
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="search box"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  required
                />
              </div>
            </form>
          </div>

          <div>

            <table id="table" >
              <tr style={{ textAlign: "center" }}>
                <th>Name</th>
                <th>Phone</th>
                <th>CompanyName</th>
                <th>Date</th>
                <th>View</th>
                <th align="center">Update</th>
              </tr>
              {users.length > 0
                ? users
                  .filter((val) => {
                    if (searchTerm === "") {
                      return val;
                    } else if (
                      val.Address.toLowerCase().indexOf(searchTerm) > -1
                    ) {
                      return val;
                    } else if (
                      val.name.toLowerCase().indexOf(searchTerm) > -1
                    ) {
                      return val;
                    } else if (
                      val.complaintNumber.toLowerCase().indexOf(searchTerm) > -1
                    ) {
                      return val;
                    }

                  })
                  .map((item, i) => (

                    <tr key={i}
                      style={{
                        color: item.complaintNumber !== "Pending" ? 'green' : 'red',
                        background: item.complaintNumber !== "Pending" ? '#a9efa9' : '#f1e0e0',
                         border: item.complaintNumber !== "Pending" ? '2px solid' : '1px solid'
                      }}>
                      <td>{item.name}</td>
                      <td>{item.pNumber}</td>
                      <td>{item.brandName}</td>
                      <td>{format(new Date(item.pDate), "dd/MM/yyyy")}</td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-primary"
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop"
                          onClick={() => ViewUsers(item)}
                        >
                          View
                        </button>
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-primary"
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop"
                          onClick={() => selectUser(item)}
                        >
                          Update
                        </button>
                      </td>
                    </tr>
                  ))
                : users && users.message}
            </table>
          </div>

          <UserModels
            name={name}
            isModalOpen={isModalOpen}
            setPNumber={setPNumber}
            setName={setName}
            pNumber={pNumber}
            setComplaintNumber={setComplaintNumber}
            complaintNumber={complaintNumber}
            updateUser={updateUser}
            textInput={textInput}
            setModalStatus={setModalStatus}
          />
          <ViewModels
            name={name}
            pNumber={pNumber}
            aNumber={aNumber}
            brandName={brandName}
            serialNumber={serialNumber}
            pDate={pDate}
            Address={Address}
            Issue={Issue}
            Pincode={Pincode}
            modal={modal}
            complaintNumber={complaintNumber}
            isModalOpen={isModalOpen2}
            setModalStatus2={setModalStatus2}
            typeOfComplaint={typeOfComplaint}
          />
        </div>
      </div>
      <div className="ref"></div>
    </>

  );
};
export default Complaints;
